<template>
  <div>
    <div :class="[currIsPc ? '' : 'bottom-mobile', 'bottom-com']">
      <div class="content">
        <div class="os">
          <div class="left">
            <p>対応OS</p>
            <p>Windows 8.1 / 10 (32bit/64bit)</p>
            <p>CPU:Core i5-4460 / AMD A8-7650K 同等以上</p>
            <p>メモリ:8GB以上必須</p>
            <p>グラフィック:GeForce GT 640 or Radeon HD 5770 以上</p>
            <p>DirectXバージョン:11以上</p>
            <p>解像度:1280×720</p>
          </div>
          <div v-if="currIsPc" class="com-header"></div>
        </div>
        <ul class="list clearfix">
          <li @click="btnFn(11, _myData.order.dmg_law_article_id)" v-if="_myData.order">
            プライバシーポリシー
          </li>
          <li @click="btnFn(21, _myData.order.dmg_rule_article_id)" v-if="_myData.order">利用規約</li>
          <li @click="btnFn(31, _myData.order.dmg_special_law_article_id)" class="noborder" v-if="_myData.order">
            特定商取引法に基づく表示
          </li>
          <li @click="btnFn(41, _myData.order.dmg_funding_decision_method)" v-if="_myData.order">
            資金決済法に基づく表示
          </li>
          <li @click="showConcat = true">お問い合わせ</li>
        </ul>
        <div class="logo"></div>
        <div class="copyright">
          © YOUNGJOY TECHNOLOGY LIMITED. All rights reserved
        </div>
      </div>
    </div>
    <DialogBs :visible.sync="showConcat">
      <ContactUs></ContactUs>
    </DialogBs>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DialogBs from "@/components/DialogBs";
import ContactUs from "@/components/ContactUs";
import { isPc, getUrlParam } from "@/util/index";
export default {
  components: { DialogBs, ContactUs },
  data() {
    return {
      showConcat: false
    };
  },
  computed: {
    ...mapState(["_myData"]),
    currIsPc() {
      return isPc();
    },
  },
  methods: {
    getPolicyUrl(id) {
      return `${window.location.origin}/protocol?id=${id}`
    },
    btnFn(code, id) {
      const url =  this.getPolicyUrl(id);
      const number =
        this.$route.name.indexOf("home") >= 0 ? `3${code}` : `4${code}`;
      if(!id) return;
      window.open(url);
    }
  },
  mounted() {
    const isFrist = sessionStorage.getItem('originStorage');
    const origin = getUrlParam('from');
    if(!isFrist && origin === 'client') {
      this.showConcat = true;
      sessionStorage.setItem('originStorage', 1)
    }
  },
};
</script>

<style lang="scss" scoped>
.bottom-com {
  background: #090d16;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 26px;
  width: 100%;
  position: relative;
  margin: auto;
  background-size: 100% 100%;
  background-position: center;
  margin-left: 50%;
  transform: translateX(-50%);
  padding-bottom: 55px;
  .content {
    width: 72%;
    min-width: 1000px;
    margin: 0 auto;
    box-sizing: border-box;
    .os {
      position: relative;
      padding: 30px 18% 50px;
      border-bottom: 1px solid #2a2a2a;
      .com-header {
        position: absolute;
        width: 190px;
        height: 190px;
        top: 30px;
        right: 18%;
        @include bg("header.png");
      }
    }

    .list {
      text-align: center;
      color: #928d71;
      li {
        display: inline-block;
        padding: 0 30px;
        border-right: 1px solid #928d71;
        font-size: 16px;
        line-height: 16px;
        margin-top: 25px;
        cursor: pointer;
        &:last-child {
          border-right: none;
        }
      }
    }

    .logo {
      width: 279px;
      height: 135px;
      @include bg("logo.png");
      margin: 20px auto 0;
    }

    .copyright {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 14px;
      color: #999999;
      text-align: center;
      margin-top: 15px;
    }
  }

  &.bottom-mobile {
    @include pb(55);
    .content {
      width: 100%;
      min-width: 100%;
      @include ft(14);
      @include lh(32);
      .os {
        padding: 0;
        @include plr(32);
        @include pt(25);
        border-bottom: none;
      }
    }

    .list {
      li {
        float: left;
        @include plr(30);
        @include ft(16);
        @include lh(16);
        border-right: 1px solid #928d71;
        @include mt(25);
        &.noborder {
          border-right: none;
        }
      }
    }

    .logo {
      @include wh(150, 72);
      margin: 0;
      @include ml(30);
      @include mt(30);
    }

    .copyright {
      @include ft(14);
      @include mt(15);
      text-align: left;
      @include ml(30);
    }
  }
}
</style>
